import {classList, dataset, listen} from 'nuffjs';

const conf = {
	cursorEffectTargetAttr: 'cursorEffectElement',
	activeClass: 'active',
};

let gsap = null;
async function getGsap() {
	if (!gsap) {
		gsap = (await import('../../external/gsap')).gsap;
	}
	return gsap;
}

class CursorEffect extends HTMLElement {
	static conf = conf;

	static defaultOpts = {
		duration: 0.2,
		menuMediaQuery: '(max-width: 1024px)',
	};

	currentTarget = null;
	isActive = false;
	isMenuInDesktopView = true;

	firstConnectedCallback() {
		this.opts = dataset(this).get(this.constructor.defaultOpts);
		this.checkMaxMenuWidth();
		listen(document.body, 'mouseenter', this.onShowCursor.bind(this), {
			capture: true,
			selector: dataset.selector(conf.cursorEffectTargetAttr),
		});
		listen(document.body, 'mouseleave', this.onHideCursor.bind(this), {
			capture: true,
			selector: dataset.selector(conf.cursorEffectTargetAttr),
		});
		listen(window, 'mousemove', this.onMouseMove.bind(this));
		listen(window, 'resize', this.onResize.bind(this), {throttle: true});
		// getGsap();
	}

	onResize(event) {
		this.checkMaxMenuWidth();
	}

	checkMaxMenuWidth() {
		this.isMenuInDesktopView = !matchMedia(this.opts.menuMediaQuery).matches;
	}

	onShowCursor(event) {
		if (!this.currentTarget) {
			const target = event.target.closest(dataset.selector(conf.cursorEffectTargetAttr));
			if (target) {
				this.currentTarget = target;
				this.isActive = true;
				classList(this).add(conf.activeClass);
				this.gotoCurrentPosition(event, false);
			}
		}
	}

	onHideCursor(event) {
		if (this.currentTarget) {
			let relatedTarget = event.relatedTarget;
			while (relatedTarget) {
				if (relatedTarget === this.currentTarget) {
					return;
				}
				relatedTarget = relatedTarget.parentNode;
			}
			this.currentTarget = null;
			this.isActive = false;
			classList(this).remove(conf.activeClass);
		}
	}

	onMouseMove(event) {
		if (this.isActive && this.isMenuInDesktopView) {
			this.gotoCurrentPosition(event, true);
		}
	}

	async gotoCurrentPosition(event, isAnimated = true) {
		const relX = event.clientX;
		const relY = event.clientY;
		await getGsap();
		gsap.to(this, isAnimated ? this.opts.duration : 0, {x: relX, y: relY});
	}
}

export {CursorEffect};
